/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react';
import { Trans } from '@lingui/macro';
import { jsx } from 'theme-ui';
import ShoppingCartButton from '../../Shop/ShoppingCartButton';
import AuthorizationModal from '../../Account/AuthorizationModal/AuthorizationModal';

/** A button to buy via Snipcart. */
export default function ProductLoginButton({ ...rest }) {
  const [dialogVisible, setDialogVisible] = React.useState(false);
  return (
    <ShoppingCartButton onClick={() => setDialogVisible(true)} {...rest}>
      <Trans>Request sample</Trans>
      {dialogVisible && (
        <AuthorizationModal
          onCancel={() => setDialogVisible(false)}
          {...rest}
        />
      )}
    </ShoppingCartButton>
  );
}
